import { RevTabItemType, SelectOption } from "@revmatics/catalyst";

export const brandTabsData: RevTabItemType[] = [
  { id: "details", title: "Details" },
  { id: "brand_guidelines", title: "Brand Guidelines" },
  { id: "social_handles", title: "Social Handles" },
];

export const brandGuidelinesTabsData: RevTabItemType[] = [
  { id: "dos_and_donts", title: "Dos and donts" },
  { id: "brand_safety", title: "Brand safety" },
  // { id: "colors", title: "Colors" },
];

export const annualizedRevenueData: SelectOption[] = [
  { value: "0-100000", label: "$0 - $100,000" },
  { value: "100000-500000", label: "$100,000 - $500,000" },
  { value: "500000-1000000", label: "$500,000 - $1,000,000" },
  { value: "1000000-3000000", label: "$1,000,000 - $3,000,000" },
  { value: "3000000-10000000", label: "$3,000,000 - $10,000,000" },
  { value: "10000000-50000000", label: "$10,000,000 - $50,000,00" },
  { value: "50000000-100000000", label: "$50,000,000 - $100,000,000" },
  { value: "100000000+", label: "$100,000,000 +" },
  { value: "unknown", label: "Unknown" },
];
